import { API_USER_URL } from 'env';
import { FcGoogle } from 'react-icons/fc';
import { useTranslation } from 'react-i18next';

export const GoogleLogin = () => {
  const { t } = useTranslation();
  const handleGoogleLogin = async () => {
    try {
      const state = Math.random().toString(36).substring(2, 15);
      sessionStorage.setItem('google_oauth_state', state);

      const response = await fetch(`${API_USER_URL}/api/v1/be/google/auth-url?redirect_uri=${encodeURIComponent(`${window.location.origin}`)}&state=${state}`, {
        method: 'GET',
        headers: { 'ngrok-skip-browser-warning': 'true'},
      });
      const data = await response.json();

      if (data.status) { 
        window.location.href = data.data.auth_url;
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <button
      type="button"
      onClick={handleGoogleLogin}
      className="w-full min-w-[240px] bg-[#e5e5e5] !text-[#000000] !text-[15px] py-3 px-4 !rounded-sm hover:!bg-black/10 transition duration-300 flex items-center justify-center gap-2"
    >
      <FcGoogle className="w-5 h-5" />
      {t('auth.with_google')}
    </button>
  );
};
